// WARNING - assuming all urls which match this represent a language code
//           not necessarily safe in future...
const urlLanguageCodeRegExp = /^\/(\w\w\w?)\//;

export default function (currentLearningLanguage, appRouter) {
  const newUrl = window.location.pathname.replace(
    urlLanguageCodeRegExp,
    "/" + currentLearningLanguage + "/"
  );
  appRouter.navigate(newUrl, { trigger: true });
}
